import { logger } from "@/utils/logger";
/**
 * Session Boundary Utility
 * 
 * Tracks when the current session started to prevent actions from
 * persisted/restored content from previous sessions.
 */

const SESSION_START_KEY = 'current_session_start_timestamp';

/**
 * Initialize a new session boundary
 * Should be called once when the app loads
 */
export const initializeSessionBoundary = (): void => {
  const existing = sessionStorage.getItem(SESSION_START_KEY);
  if (!existing) {
    const now = Date.now();
    sessionStorage.setItem(SESSION_START_KEY, now.toString());
    logger.log('🔒 Session Boundary: Initialized at', new Date(now).toISOString());
  }
};

/**
 * Get the current session start timestamp
 */
export const getSessionStartTime = (): number => {
  const timestamp = sessionStorage.getItem(SESSION_START_KEY);
  if (!timestamp) {
    // If not found, initialize now
    const now = Date.now();
    sessionStorage.setItem(SESSION_START_KEY, now.toString());
    return now;
  }
  return parseInt(timestamp);
};

/**
 * Check if a timestamp is from the current session
 * @param timestamp - The timestamp to check (in milliseconds)
 * @returns true if the timestamp is from the current session
 */
export const isFromCurrentSession = (timestamp: number | Date): boolean => {
  const sessionStart = getSessionStartTime();
  const checkTime = timestamp instanceof Date ? timestamp.getTime() : timestamp;
  return checkTime >= sessionStart;
};

/**
 * Clear the session boundary (for testing or forced reset)
 */
export const clearSessionBoundary = (): void => {
  sessionStorage.removeItem(SESSION_START_KEY);
  logger.log('🗑️ Session Boundary: Cleared');
};
